import React from 'react';

import UploadIcon from '@atlaskit/icon/glyph/upload';

import './index.css'

function MiDriveUploadIcon(props) {
    return (
        <div className='upload-icon__container' onClick={props.onClick}>
            <h6>
                <UploadIcon />
            </h6>
        </div>
    )
}

export default MiDriveUploadIcon;